import { Button } from "primereact/button";
import { Growl } from "primereact/growl";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { trackPromise } from "react-promise-tracker";
import { withRouter } from "react-router-dom";
import { HttpService } from "../../service/HttpService";
import { checkForError, clean, showMessage } from "../../utility/AppUtility";
import rule from "./../../constant/Rule";
import { Dropdown } from "primereact/dropdown";
import { TabView, TabPanel } from "primereact/tabview";
import ContectPersonAdd from "./ContectPersonAdd";
import { PriviladgeContext } from "./../../context/priviladge-context";
import { AppBreadcrumb } from "../../AppBreadcrumb";
import { InputSwitch } from "primereact/inputswitch";

var _ = require("lodash");

function PlantEdit(props) {
  var [obj, setObj] = useState({});
  const growl = useRef(null);
  var [plantProducts, setPlantProducts] = useState([]);
  var [products, setProducts] = useState([]);
  var [clients, setClients] = useState([]);
  var [contectPersons, setContectPersons] = useState([]);
  var [activeIndex, setActiveIndex] = useState(0);
  const { handleSubmit, errors, control, reset } = useForm({ mode: "onBlur" });
  const httpService = new HttpService();
  var [allowAllProduct, setAllProducts] = useState(false);

  var id = "";
  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.id === undefined
  ) {
    props.history.push("plant_list");
  } else {
    id = props.location.state.id;
  }

  useEffect(() => {
    getCustomer();
    trackPromise(
      httpService
        .getApi("plants/" + id)
        .then((response) => {
          getProduct(response.data.customer.id);
          setObj({ ...response.data });
          setAllProducts(response.data.allowAllProduct);
          setContectPersons(response.data.contectPersons);

          setPlantProducts([...response.data.plantProducts]);
          reset({ ...response.data });
        })
        .catch((error) => {
          if (checkForError(error))
            showMessage(
              "error",
              "Error Message",
              error.response.data.title,
              growl
            );
        })
    );
  }, [id]);

  const getCustomer = () => {
    trackPromise(
      httpService
        .getApi("customers/company?type=Customer")
        .then((response) => {
          setClients(response.data.content);
        })
        .catch((error) => {
          if (checkForError(error))
            showMessage(
              "error",
              "Error Message",
              error.response.data.title,
              growl
            );
        })
    );
  };

  const getProduct = (id) => {
    trackPromise(
      httpService
        .getApi("products/" + id + "/customer")
        .then((response) => {
          setProducts(response.data);
        })
        .catch((error) => {
          if (checkForError(error))
            showMessage(
              "error",
              "Error Message",
              error.response.data.title,
              growl
            );
        })
    );
  };
  const handleChange = (e, type) => {
    let val = e.target.value;
    if (e.target.name === "customer" && val !== null) {
      getProduct(val.id);
    }
    setObj({ ...obj, [e.target.name]: val });
    return val;
  };

  const cancel = () => {
    props.history.push("plant_list");
  };
  const saveContectPersons = (data) => {
    obj = clean(obj);
    obj.contectPersons = data;
    trackPromise(
      httpService
        .putApi("plants", obj)
        .then((response) => {
          cancel();
        })
        .catch((error) => {
          if (checkForError(error))
            showMessage(
              "error",
              "Error Message",
              error.response.data.title,
              growl
            );
        })
    );
  };

  const save = (data) => {
    obj = clean(obj);
    obj.plantProducts = plantProducts;
    obj.contectPersons = contectPersons;
    obj.allowAllProduct = allowAllProduct;
    trackPromise(
      httpService
        .putApi("plants", obj)
        .then((response) => {
          cancel();
        })
        .catch((error) => {
          if (checkForError(error))
            showMessage(
              "error",
              "Error Message",
              error.response.data.title,
              growl
            );
        })
    );
  };
  const deleteProduct = (id) => {
    trackPromise(
      httpService
        .postApi("plants/product/delete", id)
        .then((response) => {
          //cancel();
        })
        .catch((error) => {
          if (checkForError(error))
            showMessage(
              "error",
              "Error Message",
              error.response.data.title,
              growl
            );
        })
    );
  };
  const handleProductPlantChange = (e, index, name) => {
    const tempPlantProducts = [...plantProducts];
    const obj = { ...tempPlantProducts[index] };
    obj[name] = e.target.value;
    tempPlantProducts[index] = obj;
    setPlantProducts(tempPlantProducts);
    return e.target.value;
  };
  const addProduct = () => {
    let pp = [...plantProducts];
    pp.push({ plant: null, noOfLabelPerRoll: null });
    setPlantProducts(pp);
  };
  const deleteProduct1 = (index) => {
    let pp = [...plantProducts];
    let obj = pp[index];
    if (obj != undefined && obj.id != undefined) {
      deleteProduct(obj.id);
    }
    pp.splice(index, 1);
    setPlantProducts(pp);
  };

  return (
    <>
      <AppBreadcrumb
        breadcrumdItems={[
          { label: "Plant List", url: "#plant_list" },
          { label: "Plant Edit" },
        ]}
      />

      <div className="p-grid ">
        <Growl ref={growl} style={{ marginTop: "75px" }} />

        <div className="p-col-10 ">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <TabPanel header="Plant">
              <div className="card card-w-title">
                <h1>Edit Plant</h1>
                <div className="p-grid p-fluid form-group">
                  <div className="p-col-8">
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon">
                        <i className="material-icons">account_circle</i>
                      </span>
                      <span className="md-inputfield">
                        <Controller
                          className={errors.plantCode ? "p-error" : ""}
                          name="plantCode"
                          value={obj.plantCode}
                          rules={{
                            ...rule.RULE.requiredRule,
                            ...rule.RULE.maxLengthRuleVal100,
                          }}
                          as={InputText}
                          control={control}
                          onChange={(e) => handleChange(e[0])}
                        />
                        <label>Plant Code</label>
                      </span>
                    </div>
                    <span className="errorSpan merginLeft30">
                      {errors.plantCode?.message}
                    </span>
                  </div>
                  <div className="p-col-8">
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon">
                        <i className="material-icons">account_circle</i>
                      </span>
                      <span className="md-inputfield">
                        <Controller
                          className={errors.name ? "p-error" : ""}
                          name="name"
                          value={obj.name}
                          rules={{
                            ...rule.RULE.requiredRule,
                            ...rule.RULE.maxLengthRuleVal100,
                          }}
                          as={InputText}
                          control={control}
                          onChange={(e) => handleChange(e[0])}
                        />
                        <label>Name</label>
                      </span>
                    </div>
                    <span className="errorSpan merginLeft30">
                      {errors.name?.message}
                    </span>
                  </div>

                  <div className="p-col-8">
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon">
                        <i className="material-icons">account_circle</i>
                      </span>
                      <span className="md-inputfield">
                        <Controller
                          className={errors.address ? "p-error" : ""}
                          name="address"
                          value={obj.address}
                          rules={{
                            ...rule.RULE.requiredRule,
                            ...rule.RULE.maxLengthRuleVal100,
                          }}
                          as={InputText}
                          control={control}
                          onChange={(e) => handleChange(e[0])}
                        />
                        <label>Address</label>
                      </span>
                    </div>
                    <span className="errorSpan merginLeft30">
                      {errors.address?.message}
                    </span>
                  </div>

                  <div className="p-col-8">
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon">
                        <i className="material-icons">perm_identity</i>
                      </span>
                      <span className="md-inputfield">
                        <Controller
                          disabled={true}
                          optionLabel="companyName"
                          optionValue="id"
                          filter
                          filterBy="companyName"
                          className={errors.client ? "p-error" : ""}
                          rules={{ ...rule.RULE.requiredRule }}
                          as={Dropdown}
                          control={control}
                          options={clients}
                          placeholder={"Client"}
                          name="customer"
                          value={obj.customer}
                          onChange={(e) => handleChange(e[0])}
                        />
                      </span>
                    </div>
                    <span className="errorSpan merginLeft30">
                      {errors.client?.message}
                    </span>
                  </div>
                  <div className="p-col-8">
                    <div className="p-inputgroup">
                      <InputSwitch
                        checked={allowAllProduct}
                        name={"allowAllProduct"}
                        inputId={allowAllProduct}
                        ariaLabelledBy={allowAllProduct}
                        value={allowAllProduct}
                        onChange={() => setAllProducts(!allowAllProduct)}
                      />
                      <label
                        htmlFor={allowAllProduct}
                        className="p-checkbox-label merginLeft15"
                      >
                        All Product Add
                      </label>
                    </div>
                    <span className="errorSpan merginLeft30">
                      {errors.allowAllProduct?.message}
                    </span>
                  </div>
                  {!allowAllProduct && (
                    <>
                      <div className="p-col-8">
                        <div className="p-col-3">
                          <Button
                            icon="pi pi-plus"
                            label="Add Product"
                            onClick={addProduct.bind(this)}
                          />
                        </div>
                      </div>
                      {plantProducts.map((pp, index) => {
                        return (
                          <div className="p-col-8">
                            <div className="p-col-5 dlsplayInlineBlock">
                              <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                  <i className="material-icons">
                                    perm_identity
                                  </i>
                                </span>
                                <span className="md-inputfield">
                                  <Controller
                                    disabled={pp.id !== undefined}
                                    className={
                                      errors.plantProducts?.[index]?.product
                                        ? "p-error"
                                        : ""
                                    }
                                    optionLabel="productCode"
                                    optionValue="id"
                                    rules={{
                                      ...rule.RULE.requiredRule,
                                      ...rule.RULE.maxLengthRuleVal25,
                                    }}
                                    as={Dropdown}
                                    control={control}
                                    options={products}
                                    placeholder={"Product"}
                                    name={
                                      "plantProducts[" + index + "].product"
                                    }
                                    value={pp.product}
                                    filter
                                    onChange={(e) =>
                                      handleProductPlantChange(
                                        e[0],
                                        index,
                                        "product"
                                      )
                                    }
                                  />
                                </span>
                              </div>
                              <span className="errorSpan merginLeft30">
                                {
                                  errors?.plantProducts?.[index]?.product
                                    ?.message
                                }
                              </span>
                            </div>

                            <div className="p-col-5 dlsplayInlineBlock">
                              <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                  <i className="material-icons">
                                    account_circle
                                  </i>
                                </span>
                                <span className="md-inputfield">
                                  <Controller
                                    className={
                                      errors?.plantProducts?.[index]
                                        ?.noOfLabelPerRoll
                                        ? "p-error"
                                        : ""
                                    }
                                    name={
                                      "plantProducts[" +
                                      index +
                                      "].noOfLabelPerRoll"
                                    }
                                    type="number"
                                    value={
                                      obj?.plantProducts[index]
                                        ?.noOfLabelPerRoll
                                    }
                                    rules={{
                                      ...rule.RULE.requiredRule,
                                      ...rule.RULE.maxLengthRuleVal100,
                                    }}
                                    as={InputText}
                                    control={control}
                                    onChange={(e) =>
                                      handleProductPlantChange(
                                        e[0],
                                        index,
                                        "noOfLabelPerRoll"
                                      )
                                    }
                                  />
                                  <label>No.Of Label Per Roll</label>
                                </span>
                              </div>
                              <span className="errorSpan merginLeft30">
                                {
                                  errors?.plantProducts?.[index]
                                    ?.noOfLabelPerRoll?.message
                                }
                              </span>
                            </div>
                            <div className="p-col-2 dlsplayInlineBlock">
                              <Button
                                icon="pi-md-delete"
                                onClick={deleteProduct1.bind(this, index)}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>

                <div className="p-col-12">
                  <Button
                    icon="pi pi-check"
                    label="Save"
                    onClick={handleSubmit(save)}
                  />
                  <Button
                    icon="pi-md-cancel"
                    label="Cancel"
                    className="p-button-secondary"
                    onClick={() => cancel()}
                  />
                </div>
                <div className="p-col-8"></div>
              </div>
            </TabPanel>
            <TabPanel header="Contact Person">
              <ContectPersonAdd
                setContectPersons={saveContectPersons}
                contectPersons={contectPersons}
              ></ContectPersonAdd>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  );
}
export default withRouter(PlantEdit);
